import { render, staticRenderFns } from "./WalletDepositModal.vue?vue&type=template&id=10ac9796&"
import script from "./WalletDepositModal.vue?vue&type=script&lang=ts&"
export * from "./WalletDepositModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports